import { reactive } from 'vue'
import { defineStore } from 'pinia'
import type { ListMemory } from '@/stores/ui'

interface PageCache {
  query: Partial<ListMemory>
  updatedAt: number
}

export const useSessionCacheStore = defineStore('session-cache', () => {
  const pages = reactive<Record<string, PageCache>>({})
  const recentSearches = reactive<string[]>([])

  function cachePage(key: string, query: Partial<ListMemory>): void {
    pages[key] = { query: { ...query }, updatedAt: Date.now() }
  }

  function readPage(key: string): Partial<ListMemory> | undefined {
    return pages[key]?.query
  }

  function addRecent(value: string): void {
    const text = value.trim()
    if (!text) return
    const index = recentSearches.indexOf(text)
    if (index >= 0) recentSearches.splice(index, 1)
    recentSearches.unshift(text)
    if (recentSearches.length > 6) recentSearches.length = 6
  }

  function clear(): void {
    for (const key of Object.keys(pages)) delete pages[key]
    recentSearches.splice(0, recentSearches.length)
  }

  return { pages, recentSearches, cachePage, readPage, addRecent, clear }
})
